<template>
  <div>
    <div class="columns is-gapless has-stickyColumn has-stickyColumn--left has-stickyColumn--right">
      <div class="column is-2 is-border has-bg-white">
        <aside class="menu menu-admin">
          <ul class="menu-list">
            <li class=""
                :class="{'is-active':['ContratDeReservation', 'Financement', 'Notaire', 'Signature'].includes($route.name)}">
              <a class=""
                 @click="goToLink('ContratDeReservation')">
                Suivi de vente
              </a>
              <ul class="">
                <li class="has-bg-info-lighten-3" v-if="followUpNoteCanToggle">
                  <a class="is-padding-top-small is-padding-bottom-small is-padding-left-large is-paddingless-right"
                     style="min-height: 0"
                     @click="openNoteDeSuivi()">
                    <div class="is-uppercase is-size-7 has-text-black">
                      <!--<span v-if="displayFollowUpNote">Masquer</span><span v-else>Afficher</span> -->
                      afficher note(s) de suivi
                      <!-- <span class="is-padding-left-xsmall"><i class="fas fa-comment-alt"></i></span>-->
                    </div>
                  </a>
                </li>
                <li class="" :class="{'is-active':$route.name === 'ContratDeReservation'}">
                  <a class=""
                     @click="goToLink('ContratDeReservation')">
                    <div class="is-uppercase">
                      Dossier de réservation
                    </div>
                  </a>
                </li>
                <li v-if="isAdmin || isSectorManager || advFeuilleDeRoute.is_digital" class=""
                    :class="{'is-active':$route.name === 'Signature'}">
                  <a class=""
                     @click="goToLink('Signature')">
                    <div class="is-uppercase">Signature</div>
                  </a>
                </li>
                <li class="" :class="{'is-active':$route.name === 'Financement'}">
                  <a class=""
                     @click="goToLink('Financement')">
                    <div class="is-uppercase">
                      Financement
                    </div>
                  </a>
                </li>
                <li class="" :class="{'is-active':$route.name === 'Notaire'}">
                  <a class=""
                     @click="goToLink('Notaire')">
                    <div class="is-uppercase">Acte de vente</div>
                  </a>
                </li>
              </ul>
            </li>
            <li v-if="isAdmin || isSectorManager" class=""
                :class="{'is-active':['Commercialisation', 'SellerFacturation'].includes(this.$route.name) === true}">
              <a class=""
                 @click="goToLink('Commercialisation')">Rémunération vendeur</a>
            </li>
            <li class="" :class="{'is-active':$route.name === 'ChoixEtTma'}">
              <a class=""
                 @click="goToLink('ChoixEtTma')">Choix et TMA
              </a>
            </li>
            <li v-if="(isAdmin || isSectorManager) && isPromoteurMode" class="" :class="{'is-active':$route.name === 'AppelDeFonds'}">
              <a class=""
                 @click="goToLink('AppelDeFonds')">Appel de fonds
              </a>
            </li>
          </ul>
        </aside>
      </div>

      <div class="column is-margin-left">
        <router-view
                :source="advFeuilleDeRoute"
                :saving="saving"
                :lot="lot"
                :program="program"
                :seller="seller"
                :buyer="buyer"
                :co-buyers="coBuyers"
                :source-shares="sourceShares"
                :pending-edition="pendingEdition"
                ref="innerComponent"
                @goToSign="goToLinkSign('Signature')"
                @goToResa="goToLink('ContratDeReservation')"
                @commit="commitAdv"
                @updateCom="updateCom"
                @check="checkContrat"
                @saveAdv="saveAdv">
        </router-view>

        <div class="formActionsSticky is-bottom" v-if="canEdit && pendingEdition">
          <div class="columns is-gapless is-centered has-bg-white is-padding-top-small is-padding-bottom-small">
            <div class="column is-4 is-3-widescreen is-margin-right-small">
              <a class="button is-light is-fullwidth is-min-height-50 is-transform-none has-text-weight-medium"
                 @click="backToInitialAdv">Annuler</a>
            </div>
            <div class="column is-4 is-3-widescreen is-margin-left-small">
              <a class="button is-success is-fullwidth is-min-height-50 is-transform-none has-text-weight-medium"
                 @click="saveAdv">
                <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"
                            mode="out-in">
                  <div v-if="saving" key="saving" class="veryFastAnimation" is-success>
                    <span class="has-text-black">Enregistrement...</span>
                  </div>
                  <div v-else key="not-saving" class="veryFastAnimation">
                    <span>Enregistrer</span>
                  </div>
                </transition>
              </a>
            </div>
          </div>
        </div>
        <div v-if="(isAdmin || isSectorManager) && events && events.length > 0">
          <event-tracker-list v-if="isAdmin || isSectorManager"
                              :show-list="showLastEvents"
                              :events="lastEvents" :last-event="lastEvent"
                              :show-all="!!fullHistory && !!fullHistory.length"
                              @showAll="getFullHistory"
                              @toggle="showLastEvents = !showLastEvents">
          </event-tracker-list>
        </div>
      </div>
      <div class="column is-2 is-3-widescreen is-border has-bg-white minW250p is-margin-left"
           v-if="displayFollowUpNote">
        <div class="is-max-height-in-mainColumn">
          <div
                  class="is-marginless is-padding-right-small is-padding-left-small is-padding-top-xsmall is-padding-bottom-xsmall level is-min-height-50 is-border-bottom">
            <div class="level-left">
              <span class="is-uppercase title is-6" v-helper.bottomLeft="'4KhRsxV2khHhxnyMCezNX'">
                Note(s) de suivi
                <span class="is-padding-left-xsmall">
                  <i class="fal fa-info-circle"></i>
                </span>
              </span>
            </div>
            <div v-if="orderedNote.length !== 0" class="level-right">
              <a @click="openNewCommentQuickview" class="button is-dark is-small is-size-7 is-radius">
                <span class="icon is-small"><i class="fas fa-marker"></i></span>
                <span>Ajouter note</span>
              </a>
            </div>
          </div>

          <div v-if="orderedNote.length !== 0">
            <div class="is-padding-small">
              <template v-for="(note, idx) in showNote">
                <div :key="idx" class="vadDiscussion">
                  <div class="vadDiscussion--bulle is-size-6" :class="{ 'is-bis' : note.user !== currentUserPk}">
                    <div class="content" v-html='note.message'></div>
                  </div>
                  <div class="columns is-gapless is-size-7 is-multiline">
                    <div class="column is-12 is-7-fullhd is-margin-top-xxsmall">
                      <div><b>Date :</b> {{note.created_on|dateAdv}}</div>
                      <div><b>Auteur :</b>
                        <span v-if="note.user === currentUserPk">Vous</span>
                        <span v-else>{{note.user_last_name}} {{note.user_first_name}}</span>
                        <span>({{note.user_profil | profilTypeLabel}})</span>
                      </div>
                    </div>
                    <!-- <div class="column is-12 is-5-fullhd is-margin-top-xxsmall">
                      <input id="vpt001" type="checkbox" name="switchRoundedDefault" checked="checked"
                            class="switch is-small is-rounded is-success"> <label for="vpt001" class="is-size-7">Visible par
                      tous</label>
                    </div> -->
                  </div>
                </div>
              </template>
            </div>
            <div v-if="orderedNote.length > 4" @click="openAllNotes = !openAllNotes"
                 class="has-cursor-pointer has-bg-light is-max-height-500 is-overflow-auto is-padding-left is-padding-right">
              <div class=" is-padding-top-xsmall is-padding-bottom-xsmall is-size-6">
                <span class="icon is-small">
                  <i class="far fa-xs" :class="openAllNotes ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </span>
                <span v-if="!openAllNotes">Afficher toutes les notes</span>
                <span v-else>Masquer toutes les notes</span>
              </div>
            </div>
          </div>
          <div v-else
               class="is-marginless is-padding-right-small is-padding-left-small is-padding-top-xsmall is-padding-bottom-xsmall level is-min-height-50">
            <div class="level-left">
              <span class=""><b>Il n'y a aucune note de suivi</b></span>
            </div>
            <div class="level-right">
              <a @click="openNewCommentQuickview" class="button is-dark is-small is-size-7 is-radius">
                <span class="icon is-small"><i class="fas fa-marker"></i></span>
                <span>créer une note</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import { sortBy, reverse } from 'lodash'
  import { mapGetters, mapState } from 'vuex'
  import { AdvMx, EventTrackerMx, DefaultValues } from '@/mixins'

  export default {
    name: 'FeuilleDeRoute',
    mixins: [AdvMx, EventTrackerMx, DefaultValues],
    props: {
      lot: Object,
      program: Object,
      seller: Object,
      buyer: Object,
      coBuyers: Array,
      shares: Array,
      saving: Boolean,
      pendingEdition: Boolean,
      sourceShares: Array,
      sourceNotes: Array,
      source: Object
    },
    data () {
      return {
        openAllNotes: false,
        notes: [],
        service: this.$api.advService,
        isCheck: false,
        reservation: false,
        displayFollowUpNote: true,
        wWidth: null
      }
    },
    filters: {
      dateAdv: function (value) {
        let date = moment(value).format('DD/MM/YYYY')
        let hour = moment(value).format('HH')
        let minute = moment(value).format('mm')

        return date + ' - ' + hour + ':' + minute
      }
    },
    computed: {
      ...mapState(['quickview']),
      ...mapGetters(['isPromoteurMode']),
      showNote () {
        if (this.openAllNotes) {
          return this.orderedNote
        } else {
          return this.firstOrderedNote
        }
      },
      eventEntity () {
        return this.advFeuilleDeRoute
      },
      ...mapGetters(['currentUserPk', 'isAdmin', 'isSectorManager', 'isPromoteurMode', 'isSeller', 'isExternal']),
      advPk () {
        return this.$route.params.id
      },
      firstOrderedNote () {
        return this.orderedNote.slice(0, 4)
      },
      orderedNote () {
        return reverse(sortBy(this.notes, 'created_on'))
      },
      events () {
        return this.advFeuilleDeRoute.events
      },
      advFeuilleDeRoute () {
        return this.source
      },
      followUpNoteCanToggle () {
        // Si on peut toggle les notes de suivi
        if (this.followUpNoteIsForbidden) {
          return false
        } else if ((this.isAdmin || this.isSectorManager) && this.wWidth < 1280) {
          return true
        } else if (!(this.isAdmin || this.isSectorManager)) {
          return true
        } else {
          return false
        }
      },
      followUpNoteIsForbidden () {
        // Ici les cas de figures ou les notes sont interdites
        // Page ou les notes ne sont pas visibles
        if (['Commercialisation', 'ChoixEtTma', 'AppelDeFonds', 'SellerFacturation'].includes(this.$route.name) === true) {
          return true
        } else {
          return false
        }
      }
    },
    watch: {
      '$route' (to, from) {
        if (to.name !== from.name) {
          this.verifDisplayFollowUpNote()
        }
      },
      quickview ({ mode, params, results }) {
        if (results) {
          if (mode === 'NEW_NOTE') {
            this.addNoteAdv(results)
          }
        }
      }
    },
    methods: {
      openNoteDeSuivi () {
        this.$store.commit('setQuickview', { mode: 'NOTES_ADV', params: { source: this.orderedNote } })
      },
      addNoteAdv (comment) {
        this.$api.advService.postNote(this.advPk, { message: comment }).then(r => {
          this.notes.push(r.data)
        })
      },
      openNewCommentQuickview () {
        this.$store.commit('setQuickview', { mode: 'NEW_NOTE' })
      },
      updateCom () {
        this.$emit('updateCom')
      },
      goToLink (link) {
        this.$router.push({ name: link, params: { id: this.advFeuilleDeRoute.pk } })
      },
      goToLinkSign (link) {
        this.$router.push({ name: link, params: { id: this.advFeuilleDeRoute.pk, from: 'modal' } })
      },
      checkContrat (v) {
        this.isCheck = v
      },
      calculReSizesScreen () {
        this.wWidth = window.innerWidth
        this.verifDisplayFollowUpNote()
      },
      verifDisplayFollowUpNote () {
        // Verification si les notes sont visible ou non
        if (this.followUpNoteIsForbidden) {
          this.displayFollowUpNote = false // ON masque les notes si l'affichage y est interdit
          return true
        } else if ((this.isAdmin || this.isSectorManager) && this.followUpNoteCanToggle) {
          this.displayFollowUpNote = false // ON masque les notes
        } else if (!(this.isAdmin || this.isSectorManager)) {
          this.displayFollowUpNote = false // ON masque les notes automatiquement si on est pas admin
        } else {
          this.displayFollowUpNote = true
        }
      }
    },
    created () {
      if (this.$route.params.go === 'taux de com') {
        this.goToLink('Commercialisation')
      } else if (this.$route.params.go === 'contrat') {
        this.goToLink('ContratDeReservation')
      } else if (this.$route.params.go === 'financement') {
        this.goToLink('Financement')
      }
      setTimeout(() => {
        this.notes = this.sourceNotes
      }, 100)
    },
    mounted () {
      this.calculReSizesScreen()
      window.addEventListener('resize', this.calculReSizesScreen)
    },
    destroyed () {
      window.removeEventListener('resize', this.calculReSizesScreen)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/adv/FeuilleDeRoute/FeuilleDeRoute.vue